import { render, staticRenderFns } from "./IndexCreator.vue?vue&type=template&id=252eb644&"
import script from "./IndexCreator.vue?vue&type=script&lang=js&"
export * from "./IndexCreator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports